/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Uno_Welcome_ContinueInputs */



/**
* | output |
* | --- |
* | "Here I am, {name}. This is my spot from now on - ask me anything about oneAI, any time. You told me what you want to use oneAI for: pick one and we'll start." |
*
* @param {Uno_Welcome_ContinueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_welcome_continue = /** @type {((inputs: Uno_Welcome_ContinueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Welcome_ContinueInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Da bin ich, ${i?.name}. Hier findest du mich ab jetzt - frag mich jederzeit alles zu oneAI. Du hast mir erzählt, wofür du oneAI nutzen möchtest: Such dir etwas aus, und wir legen los.`)
	return /** @type {LocalizedString} */ (`Here I am, ${i?.name}. This is my spot from now on - ask me anything about oneAI, any time. You told me what you want to use oneAI for: pick one and we'll start.`)
});